import React, { useContext, Fragment } from "react";
import { ThemeContext } from "styled-components";
import {
  ButtonWithLink,
  ButtonWithAction,
  Box,
  Cluster,
  SolidDivider,
  util
} from "@thecb/components";

const { kebabCaseString } = util.general;

const PaymentButtonBar = ({
  isForwardButtonDisabled = false,
  forwardButtonText = "Next",
  forwardButtonAction,
  forwardButtonLoading,
  forwardButtonVariant = "primary",
  forwardButtonAriaRole = "button",
  backButtonVariant = "secondary",
  backButtonAction,
  cancelURL,
  cancelText = "Cancel",
  redirectURL,
  redirectText = "Return",
  buttonFlexOverride,
  hideForwardButton = false,
  hideBackButton = false,
  buttonGroupStyles,
  hideAdditionalButton = false,
  additionalButton,
  nextButtonTestId = null,
  backButtonTestId = null
}) => {
  const { isMobile } = useContext(ThemeContext);

  // cancel URLs are external (back to client system)
  const handleCancel = () => {
    window.location.href = cancelURL;
  };

  const backButton =
    !!cancelURL && !!cancelText ? (
      <ButtonWithAction
        text={cancelText}
        action={handleCancel}
        variant={backButtonVariant}
        extraStyles={isMobile && "flex-grow: 1"}
        dataQa={backButtonTestId || cancelText}
        aria-label={`${cancelText}, navigate back to previous site`}
        role="link"
      />
    ) : (
      backButtonAction && (
        <ButtonWithAction
          text="Back"
          variant={backButtonVariant}
          action={backButtonAction}
          extraStyles={isMobile && "flex-grow: 1"}
          dataQa="Back"
          aria-label={"Back, navigate to previous page"}
          role="link"
        />
      )
    );

  const forwardButton = !!redirectURL ? (
    <ButtonWithLink
      url={redirectURL}
      text={redirectText}
      variant={forwardButtonVariant}
      extraStyles={isMobile && "flex-grow: 1"}
      dataQa={nextButtonTestId || redirectText}
      disabled={isForwardButtonDisabled}
      aria-labelledby={`${kebabCaseString(redirectText)}-button`}
      role={forwardButtonAriaRole}
    />
  ) : (
    forwardButtonAction && (
      <ButtonWithAction
        text={forwardButtonText}
        variant={forwardButtonVariant}
        action={forwardButtonAction}
        isLoading={forwardButtonLoading}
        extraStyles={isMobile && "flex-grow: 1"}
        dataQa={nextButtonTestId || forwardButtonText}
        disabled={isForwardButtonDisabled}
        aria-labelledby={`${kebabCaseString(forwardButtonText)}-button`}
        role={forwardButtonAriaRole}
      />
    )
  );

  return (
    <Fragment>
      <Box padding="1.25rem 0" />
      <SolidDivider />
      <Box padding="2.5rem 0 3.125rem 0">
        <Cluster
          justify={
            buttonFlexOverride
              ? buttonFlexOverride
              : !!backButton
              ? "space-between"
              : "flex-end"
          }
          align="center"
          extraStyles={buttonGroupStyles}
        >
          {!hideBackButton && <Fragment>{backButton}</Fragment>}
          {!hideForwardButton && <Fragment>{forwardButton}</Fragment>}
          {!hideAdditionalButton && <Fragment>{additionalButton}</Fragment>}
        </Cluster>
      </Box>
    </Fragment>
  );
};

export default PaymentButtonBar;
